import { useTranslation } from 'react-i18next';

import { Wrapper, EmojiWrapper, Title, Description, TextWrapper } from './EmptyDeliverables.styles';

export const EmptyDeliverables: React.FC = () => {
  const { t } = useTranslation('StudentDashboardTranslations');

  return (
    <Wrapper>
      <EmojiWrapper>
        <span role="img" aria-label="mailbox">
          📬
        </span>
      </EmojiWrapper>
      <TextWrapper>
        <Title>{t('EMPTY_DELIVERABLES_TITLE')}</Title>
        <Description>{t('EMPTY_DELIVERABLES_DESCRIPTION')}</Description>
      </TextWrapper>
    </Wrapper>
  );
};
